<template lang="pug">
    
        //v-btn(@click="validateAllForms()") test
        v-card.py-5
            slot
            v-divider(v-if="crudOption==='show-edit' && _optionType")
            v-layout(row wrap v-if="crudOption==='show-edit' && _optionType" pt-2)
                v-flex(offset-md1)
                    .controls-area
                        .switch-container
                            span.mr-2.ml-3.title.pt-1 Editar
                            v-switch.switch(v-model="editSwitch")
            v-divider
            v-card-text
                v-layout(row wrap align-center justify-center
                    v-for="(discount, index) in arrayDiscounts"
                    :key="discount"    
                )
                    
                    v-flex(offset-md1)
                        discount(:ref="'discount' + index" :index='index' :editable="editing")
                v-layout(row wrap v-if="editing")
                    v-flex(offset-md1)
                        v-btn.white--text(color="success" title="Agregar nuevo descuento por cantidad"
                            @click="addDiscount")
                            | Agregar
                            v-icon(right dark) add_circle
            v-divider(v-show="showValidations")
            validations(v-show="showValidations")
            //- span {{showValidations}}
            v-divider
            v-card-actions(v-if="editing")
                v-layout(row wrap align-center justify-center)
                    v-flex.px-3(xs12 md4 v-if="!hideBtnBack")
                        v-btn.subheading.mt-3(v-if="crudOption!='create'" block outline color="error" @click="cancelEditing")
                            v-icon(left dark) undo
                            | deshacer cambios
                        v-btn.subheading.mt-3(v-else block outline color="error" @click="cancelEditing")
                            v-icon(left dark) undo
                            | Volver
                            
                    v-flex.px-3(xs12 md4)
                        v-btn.subheading.mt-3(block outline color="secondary" @click="clearForm()")
                            | Eliminar todos descuentos
                            // v-icon(right dark) brush
                    v-flex.px-3(xs12 md4 v-if="quantitiesSorted")
                        v-btn.subheading.mt-3(block color="secondary" @click="submitForm()"
                        ) {{submitText}}
                            v-icon(right dark) publish
                            // también puede er cloud_upload
                    v-flex.px-3(xs12 md4 v-else)
                        v-btn.white--text.subheading.mt-3(block color="red darken-4" @click="sortDiscountsByQuantity()" title="Debe ordenar el esquema por cantidades antes de poder confirmar")
                            | ORDENAR CANTIDADES
                            v-icon(right dark) swap_vert
            v-card-actions(v-else)
                v-layout(row wrap align-center)
                    v-flex.px-3(xs12 md4)
                        v-btn.subheading.mt-3(block outline color="error" @click="$emit('return-previous-route')") Volver
</template>

<script>
import Discount from './Discount'
import Validations from './Validations'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
    name: 'manager-wholesale-discounts',
    props: {
        /**
         * @description
         */
        submitText: {
            type: String,
            default: () => 'Submit',
        },

        crudOption: {
            type: String,
            default: () => 'edit-show',
        },

        optionType: {
            type: String,
            default: () => 'family',
        },
        hideBtnBack:{
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            editSwitch: false,
            showValidations: false,
        }
    },
    computed: {
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
        }),
        ...mapGetters('WholesaleDiscountModule', {
            allDataSet: 'allDataSet',
            allDataValid: 'allDataValid',
            discountsSorted: 'discountsSorted',
            quantitiesSorted: 'quantitiesSorted',
            lengthArrayDiscounts: 'lengthArrayDiscounts',
        }),
        editing() {
            if (this.crudOption === 'create') {
                return true
            } else {
                return this.editSwitch
            }
        },
        formIsSubmittable() {
            if (
                this.crudOption != 'create' &&
                this.arrayDiscounts.length === 0
            ) {
                return true
            } else {
                return (
                    this.allDataSet && this.allDataValid && this.discountsSorted
                )
            }
        },
        _optionType() {
            let type = this.optionType
            if (type === 'family')
                return this.$can('EDIT_WHOLESALE_DISCOUNT_BY_FAMILY')
            else if (type === 'subfamily')
                return this.$can('EDIT_WHOLESALE_DISCOUNT_BY_SUBFAMILY')
            else if (type === 'product')
                return true
        },
    },
    methods: {
        ...mapActions('WholesaleDiscountModule', {
            addDiscount: 'addDiscount',
            deleteDiscount: 'deleteDiscount',
            sortDiscountsByQuantity: 'sortDiscountsByQuantity',
        }),

        deteleCurrentDiscount(index) {
            this.deleteDiscount(index)
        },

        submitForm() {
            if (!this.formIsSubmittable) {
                this.showValidations = true
            } else {
                this.showValidations = false
                if (this.arrayDiscounts.length != 0) {
                    this.$emit('submit-form')
                } else {
                    this.$emit('delete')
                }
            }
        },

        clearForm() {
            this.showValidations = false
            this.$emit('clear-form')
        },

        cancelEditing() {
            this.showValidations = false
            this.$emit('cancel-editing')
            // if(this.crudOption != 'create'){
            //     this.editSwitch = false
            // }
        },
        // validateAllForms() {
        //     let count = this.lengthArrayDiscounts
        //     for (let idx = 0; idx < count; idx++) {
        //         console.log(this.$refs[`discount${idx}`].$refs.form.validate())
        //     }
        // },
    },
    watch: {
        /**
         * @description
         */
        editSwitch: function(newVal, oldVal) {
            if (oldVal) {
                this.$emit('cancel-editing')
            }
        },

        formIsSubmittable: function(newVal, oldVal) {
            if (newVal) {
                this.showValidations = false
            }
        },
    },
    components: { Discount, Validations },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.controls-area {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .switch-container {
        display: flex;
        flex-direction: row;
        // padding-top: 2.5%;
        span {
            margin-top: 1px;
        }
    }
    .switch {
        margin-top: -2px;
        margin-left: 10px;
    }
}
</style>